import React from 'react';
export function Divider() {
  return <section className="bg-lavender-soft py-20 border-y border-ink/5" data-id="element-32">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-33">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-ink" data-id="element-34">
          ¿Listo para ir más allá del{' '}
          <em className="text-accent-light italic" data-id="element-35">primer paso</em>?
        </h2>
      </div>
    </section>;
}